"use strict";

var DataSourcedMixin, DynamicDefinition, React, isEqual;

React = require("react");

DataSourcedMixin = require("../controls/mixins/DataSourced");

isEqual = require("lodash/isEqual");

DynamicDefinition = React.createClass({
  displayName: "DynamicDefinition",

  mixins: [DataSourcedMixin],
  propTypes: {
    dataKey: React.PropTypes.string
  },
  componentDidMount: function componentDidMount() {
    return this.props.onDataChanged(this.props.dataKey, this.state.formDef);
  },
  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
    if (!isEqual(this.state.formDef, nextState.formDef)) {
      return this.props.onDataChanged(nextProps.dataKey, nextState.formDef);
    }
  },
  render: function render() {
    return React.createElement(
      "div",
      null,
      this.props.children
    );
  }
});

module.exports = DynamicDefinition;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/containers/DynamicDefinition.js
 ** module id = 588
 ** module chunks = 0
 **/